/**
 * The Go box's best-guess endpoint: which page a phrase that matched no
 * destination asks for, answered by a fast model on the server.
 */
import { DESTINATION_KEYWORDS } from '@shared/navigation/destinationKeywords';
import { DESTINATIONS } from '@shared/navigation/destinations';
import { apiPost } from '@shared/services/api';

/** As `POST /api/nav/best-guess` returns it. */
interface BestGuessResponse {
  destination_id: string | null;
}

/**
 * The catalog as the guess sees it; All areas is the launcher, never a guess.
 * Keywords go too: without them the model sent "newsletter" to Paper Trail.
 */
function candidates() {
  return DESTINATIONS.filter(d => d.id !== 'areas').map(d => ({
    id: d.id,
    label: d.label,
    description: d.description,
    keywords: DESTINATION_KEYWORDS[d.id] ?? [],
  }));
}

/**
 * Ask the server which destination `query` most likely means.
 *
 * @returns A catalog id, or null when the server has no guess.
 */
export async function fetchBestGuess(query: string, signal: AbortSignal): Promise<string | null> {
  const reply = await apiPost<BestGuessResponse>(
    '/api/nav/best-guess',
    { query, candidates: candidates() },
    { signal }
  );
  return reply.destination_id;
}
